module.exports = __webpack_public_path__ + "img/pres-04.717242ce.png";